import { NavigationGuard } from 'vue-router'
import { usePlansStore } from '@/store/pinia/plans'

export const hasPlan: NavigationGuard = (to, from, next) => {
  const plansStore = usePlansStore()
  if (plansStore.selectedPlan) next()
  else next({ name: 'plan' })
}
